import axiosInstance from '../axiosInterceptor/axiosInstance'
import { stringify } from 'query-string'
import selectedOrgId from '../../utils/helpers/selectedOrgId'

// The selected org's players (the backend always listed the Org-Id header's, whatever orgId the query named).
const getOrgPlayers = async ({ teamId, eventTeamId, Q, page, perPage }) => {
  const queryParams = { OrderBy: '-FirstName', page: 1, perPage: perPage || 50 }

  if (teamId) {
    queryParams.teamId = teamId
  }
  if (eventTeamId) {
    queryParams.eventTeamId = eventTeamId
  }
  if (Q) {
    queryParams.Q = Q
  }
  if (page) {
    queryParams.page = page
  }

  const url = `v1/orgs/${selectedOrgId()}/players?${stringify(queryParams)}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getOrgPlayers
